import { render, staticRenderFns } from "./note-tab.vue?vue&type=template&id=c79ad098"
import script from "./note-tab.vue?vue&type=script&lang=js"
export * from "./note-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports